import PropTypes from 'prop-types';
import insurance from './insurance';

const insurancesShape = PropTypes.arrayOf(insurance);

export default insurancesShape;
